export default __webpack_public_path__ + "static/media/theH.5d3faade.png";